import { Link, useParams } from 'react-router-dom';
import { useState, useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.scss';

function DoctorScreen() {
    const { doctorId } = useParams();
    const [doctor, setDoctor] = useState(null);
    const navigate = useNavigate();

    useLayoutEffect(() => {
        window.scrollTo(0, 0); // Görgessen a tetejére, amikor a komponens betöltődik vagy változik a doctorId
    }, [doctorId]); 

    useEffect(() => {
        fetch('/DoctorsData.json')
            .then(response => response.json())
            .then(data => {
                const allDoctors = Object.values(data).flat();
                const foundDoctor = allDoctors.find(doc => doc.id === doctorId);
                if (!foundDoctor) {
                    navigate('*');
                } else {
                    setDoctor(foundDoctor);
                }
            })
            .catch(error => console.error("Hiba történt az adatok betöltésekor:", error));
    }, [doctorId, navigate]);

    if (!doctor) {
        return null; // addig ne rendereljen semmit, amíg betölt
    }

    const goToPrices = () => {
        navigate(`/prices?doctor=${encodeURIComponent(doctor.name)}`);
    };

    return (
        <section className="doctor-details fadeIn">
            <div className="container">
                <div className='doctor-card'>
                    <div 
                        className={`profile-image ${doctor.customClass || ""}`} 
                        style={{ backgroundImage: `url(${doctor.image})` }} 
                        alt={doctor.name}>
                    </div>
                    <div className='doctor-info'>
                        <h1 className="name">{doctor.name}</h1>
                        <div className='name-description'> 
                            <h2 className='title'> {doctor.title} </h2>
                            <p className='specialty'> {doctor.company} </p>
                        </div>
                        <h3>Specializáció</h3>
                        <p className="specialty">{doctor.specialty}</p>
                        <p className="bio">{doctor.bio}</p>
                        <div className="contact-info">
                            <h3 className='headline'>Bejelentkezés</h3>
                            {doctor.praxisTime && <p>{doctor.praxisTime}</p>}
                            <p className='contact-description'>{doctor.contactInfo}</p>

                            {doctor.mobil && (
                                <p>
                                    <strong>Telefonos bejelentkezés {doctor.contactPeriod}:</strong>{' '}
                                    <a href={`tel:${doctor.mobil}`}>{doctor.mobil}</a>
                                </p>
                            )}

                            <p>
                                <span><strong>{doctor.onlineBooking}</strong></span>
                                <Link to={doctor.booking1}>{doctor.booking1}</Link>
                            </p>

                            {doctor.booking2 && (
                                <p>
                                    <span><strong>{doctor.onlineBooking2}</strong></span>
                                    <Link to={doctor.booking2}>{doctor.booking2}</Link>
                                </p>
                            )}

                            {doctor.booking3 && (
                                <p>
                                    <span><strong>{doctor.onlineBooking3}</strong></span>
                                    <Link to={doctor.booking3}>{doctor.booking3}</Link>
                                </p>
                            )}

                            <div className='price-button'>
                                <button className='button' onClick={goToPrices}>
                                    Áraink
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DoctorScreen;

